export const siteConfig = {
  name: 'Mendly | Software de gestión para talleres de reparación',
  url: 'https://mendly.com.ar',
  apiUrl: 'https://api.mendly.com.ar',
  ogImage: 'https://mendly.com.ar/og-image.png',
  description:
    'Software de gestión para talleres de reparación de electrónica. Organizá clientes, seguimientos, presupuestos y reparaciones de forma simple y profesional.',
  keywords: [
    'software talleres reparación',
    'gestión talleres electrónica',
    'sistema reparaciones Argentina',
    'software servicio técnico',
    'Mendly Argentina',
    'gestión clientes talleres',
    'presupuestos electrónica',
    'seguimiento reparaciones',
    'talleres electrónicos',
    'software reparación dispositivos',
  ],
  links: {
    instagram: 'https://www.instagram.com/mendly.ok',
    facebook: 'https://www.facebook.com/mendly.ok',
    email: 'mailto:contacto@mendly.com.ar',
  },
};

export type SiteConfig = typeof siteConfig;

export const META_THEME_COLORS = {
  light: '#faf9f6',
  dark: '#0e1116',
};
